import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [["current", "Current password", "current-password"], ["next", "New password (at least 8 characters)", "new-password"], ["confirm", "Repeat new password", "new-password"]];
const EMPTY = { current: "", next: "", confirm: "" };

export const ChangePassword = () => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (f.next.length < 8) return setError("New password must be at least 8 characters.");
    if (f.next !== f.confirm) return setError("The new passwords don't match.");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next });
      setF(EMPTY);
      toast.success("Password changed");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="mt-10 max-w-3xl space-y-5 rounded-2xl border border-clay bg-white p-6 sm:p-8" data-testid="change-password-form">
      <div>
        <h2 className="flex items-center gap-2 text-xl font-black text-forest"><KeyRound className="h-5 w-5" /> Change password</h2>
        <p className="mt-1 text-xs font-medium text-moss">Use a private password only you know. You'll stay logged in after changing it.</p>
      </div>
      <div className="grid gap-5 sm:grid-cols-3">
        {FIELDS.map(([k, label, ac]) => (
          <div key={k} className="space-y-2">
            <Label className="font-bold">{label}</Label>
            <Input type="password" required autoComplete={ac} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`change-password-${k}`} />
          </div>
        ))}
      </div>
      {error && <p className="text-sm font-semibold text-destructive" data-testid="change-password-error">{error}</p>}
      <button type="submit" disabled={busy} className="btn-primary" data-testid="change-password-submit">
        {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update password
      </button>
    </form>
  );
};
